import React, { useState, useEffect } from "react";
import "./Hero.css";
import linkedin_img from "../../assets/linkedin.png";
import github_img from "../../assets/icons8-github-48.png";

const Hero = () => {
  const [text, setText] = useState("");
  const fullText = "Full Stack Software Engineer";

  useEffect(() => {
    let index = 0;

    const typeEffect = () => {
      const interval = setInterval(() => {
        setText((prev) => prev + fullText[index]);
        index++;

        if (index === fullText.length) {
          clearInterval(interval); 
          setTimeout(() => {
            setText(""); 
            index = 0; 
            typeEffect(); 
          }, 4000); 
        }
      }, 100); 
    };

    typeEffect(); 

    return () => clearInterval(typeEffect); 
  }, [fullText]);

  return (
    <div className="home">
      <h1>{text}</h1>
      <h2>
        Hi, I'm <span>Antonio Alfaro</span> a Full Stack Software Engineer based in USA
      </h2>
      <div className="connect">
        <span>Connect with me!</span>
      </div>
      <div className="logos">
        <a href="https://www.linkedin.com/in/antonio-alfaro-6162a2237/" target="_blank" rel="noopener noreferrer">
          <img src={linkedin_img} alt="LinkedIn" />
        </a>
        <a href="https://github.com/antonioalfaroa" target="_blank" rel="noopener noreferrer">
          <img src={github_img} alt="GitHub" />
        </a>
      </div>
    </div>
  );
};

export default Hero;
